import { createFileRoute } from '@tanstack/react-router';
import { FillScreen } from '@/components/Layout';
import { DataScopePermissionsSettings } from './-components/DataScopePermissionsSettings';
export const Route = createFileRoute('/_staff/settings/permission-and-roles/_list/data-scope-permissions/')({
  component: RouteComponent
});
function RouteComponent() {
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <DataScopePermissionsSettings />
    </FillScreen>;
}